/**
 * Constantes gerais da aplicação
 * Portal ICAVI - Application Constants
 */
// ============================================================================
// Constants
// ============================================================================
/**
 * Informações básicas da aplicação Portal ICAVI
 */
export const APP_INFO = {
    NAME: 'Portal ICAVI',
    COMPANY: 'ICAVI - Indústria de Caldeiras Vale do Itajaí',
    DESCRIPTION: 'Sistema de gestão empresarial',
};
/**
 * Chaves utilizadas para armazenamento local (localStorage)
 */
export const LOCAL_STORAGE_KEYS = {
    TOKEN: 'token',
    REFRESH_TOKEN: 'refresh_token',
    USER: 'user',
    THEME: 'theme',
    LANGUAGE: 'language',
    PREFERENCES: 'preferences',
    DESPESAS_CONFERENCIA_MOVIMENTACOES_FILTERS: 'despesas_conferencia_movimentacoes_filters_v1',
    DESPESAS_CONFERENCIA_ENTRADAS_INICIAIS: 'despesas_conferencia_entradas_iniciais_v1',
    DESPESAS_CONFERENCIA_CARDS_INICIO: 'despesas_conferencia_cards_inicio_v1',
    DESPESAS_CONFERENCIA_LANCADAS_COLUMN_WIDTHS: 'despesas_conferencia_lancadas_column_widths_v3',
    DESPESAS_CONFERENCIA_RECENT_COLORS: 'despesas_conferencia_recent_colors_v1',
    RNC_CHART_TYPES: 'rnc_chart_types_v2',
    RNC_RELATORIOS_LAYOUT: 'rnc_relatorios_layout_v3',
    RNC_HIDDEN_CHARTS: 'rnc_hidden_charts',
    RNC_CHART_DATE_FILTERS: 'rnc_chart_date_filters_v1',
    RNC_HIDDEN_CHART_DATE_FIELDS: 'rnc_hidden_chart_date_fields_v1',
    RNC_CHART_LABEL_WIDTHS: 'rnc_chart_label_widths_v1',
    RNC_OCORRENCIAS_LAYOUT: 'rnc_ocorrencias_layout_v3',
    RNC_OCORRENCIAS_HIDDEN_CHARTS: 'rnc_ocorrencias_hidden_charts',
    RNC_OCORRENCIAS_CHART_TYPES: 'rnc_ocorrencias_chart_types_v2',
    RNC_OCORRENCIAS_CHART_DATE_FILTERS: 'rnc_ocorrencias_chart_date_filters_v1',
    RNC_OCORRENCIAS_HIDDEN_CHART_DATE_FIELDS: 'rnc_ocorrencias_hidden_chart_date_fields_v1',
    RNC_OCORRENCIAS_CHART_LABEL_WIDTHS: 'rnc_ocorrencias_chart_label_widths_v1',
    SAVING_COMPRAS_LAYOUT: 'saving_compras_layout_v1',
    SAVING_COMPRAS_HIDDEN_CHARTS: 'saving_compras_hidden_charts_v1',
    SAVING_COMPRAS_CHART_TYPES: 'saving_compras_chart_types_v1',
    SAVING_COMPRAS_CHART_UNITS: 'saving_compras_chart_units_v1',
    SAVING_COMPRAS_CHART_LABEL_WIDTHS: 'saving_compras_chart_label_widths_v1',
};
/**
 * Chaves utilizadas para armazenamento de sessão (sessionStorage)
 */
export const SESSION_STORAGE_KEYS = {
    CURRENT_PAGE: 'current_page',
    FORM_DATA: 'form_data',
    FILTERS: 'filters',
};
/**
 * Formatos de data padrão utilizados na aplicação
 */
export const DATE_FORMATS = {
    DISPLAY: 'DD/MM/YYYY',
    DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
    API: 'YYYY-MM-DD',
    API_WITH_TIME: 'YYYY-MM-DD HH:mm:ss',
};
/**
 * Configurações padrão de paginação
 */
export const PAGINATION = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
    MAX_VISIBLE_PAGES: 5,
};
/**
 * Sistema de permissões - módulos e ações
 */
export const PERMISSIONS = {
    MODULES: {
        USUARIOS: 'usuarios',
        PERFIS: 'perfis',
        COLABORADORES: 'colaboradores',
        HORA_EXTRA: 'hora_extra',
        CARROS: 'carros',
        RECEPCAO: 'recepcao',
        PORTARIA: 'portaria',
        CHAT: 'chat',
        SISTEMA: 'sistema',
        RELATORIOS: 'relatorios',
    },
    ACTIONS: {
        ACESSAR: 'acessar',
        VISUALIZAR: 'visualizar',
        CRIAR: 'criar',
        EDITAR: 'editar',
        EXCLUIR: 'excluir',
        APROVAR: 'aprovar',
        ATRIBUIR: 'atribuir',
        FECHAR: 'fechar',
        MODERAR: 'moderar',
        CONFIGURAR: 'configurar',
        BACKUP: 'backup',
        LOGS: 'logs',
        EXPORTAR: 'exportar',
    },
};
/**
 * Papéis de usuário disponíveis no sistema
 */
export const USER_ROLES = {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Administrador',
    SUPERVISOR: 'Supervisor',
    USER: 'Usuário',
    OPERATOR: 'Operador',
};
/**
 * Eventos WebSocket para comunicação em tempo real
 */
export const WEBSOCKET_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    JOIN_ROOM: 'join_room',
    LEAVE_ROOM: 'leave_room',
    SEND_MESSAGE: 'send_message',
    NEW_MESSAGE: 'new_message',
    USER_ONLINE: 'user_online',
    USER_OFFLINE: 'user_offline',
};
